// extracted by mini-css-extract-plugin
export var currencyInput = "_j7-1";
export var currencySymbol = "_j7-0";